import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Modal as BootstrapModal } from 'react-bootstrap';

import { useToast } from '../../../hooks/toast';

import getResponseErrors from '../../../utils/getResponseErrors';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Input';

import { Container, FormGroup } from './styles';
import { useReceita } from '../../../hooks/receita';

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (logado: boolean) => void;
}

const LoginPrescreve: React.FC<Props> = ({ show, onClose, onSave }) => {
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const { loginPrescreve } = useReceita();

  const handleSubmit = useCallback(
    async (dados: { email: string; senha: string }) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});

        const { email, senha } = dados;

        await loginPrescreve(email, senha);

        onSave(true);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        }
        const mensagem = getResponseErrors(error);
        addToast({
          title: 'Não foi possível realizar o login',
          type: 'error',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [loginPrescreve, onSave, addToast],
  );

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  if (!show) return null;

  return (
    <BootstrapModal show={show} onHide={handleClose} size="lg" centered>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>Login Parceiro Prescreve</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
        <p>
          Para assinar documentos é necessário realizar o logina no sistema
          Prescreve.
        </p>
        <p>
          Utilize o e-mail e senha cadastrado na Prescreve para realizar a
          autenticação.
        </p>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Container>
            <FormGroup>
              <Input
                name="email"
                label="Seu Email na Prescreve *"
                placeholder="email de cadastro na Prescreve"
                type="email"
                maxLength={250}
                required
              />

              <Input
                name="senha"
                label="Sua Senha da Prescreve *"
                placeholder="Senha cadastrada na Prescreve"
                type="password"
                maxLength={250}
                required
              />
            </FormGroup>
          </Container>

          <BootstrapModal.Footer>
            <Button
              type="button"
              variant="secondary"
              onClick={handleClose}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button type="submit" variant="success" disabled={loading}>
              {!loading ? 'Login Prescreve' : 'autenticando...'}
            </Button>
          </BootstrapModal.Footer>
        </Form>
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

export default LoginPrescreve;
